// -----------------------------------------------------------------------------
// Scrollbar sections
// -----------------------------------------------------------------------------

function scrollbarSections() {

  $('.scrollbar-inner').scrollbar();

}